import React from 'react';
import { FadeIn, Section } from './Section';
import { PricingSelector } from './PricingSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function Pricing() {
  return <Section bg="cream-dark" id="pricing" className="py-10 md:py-24" data-id="element-212">
      <FadeIn className="text-center mb-6 md:mb-10" data-id="element-213">
        <h2 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-plum/60 mb-3 md:mb-4" data-id="element-214">
          Elegí tu Mujer Expansiva
        </h2>
        <p className="font-serif text-2xl md:text-4xl text-plum px-2 leading-tight" data-id="element-215">
          Dos opciones. Una decisión que cambia todo.
        </p>
        <p className="text-xs md:text-sm text-plum/60 mt-2 md:mt-3" data-id="element-216">
          Ambas incluyen los 5 bonos estratégicos completos
        </p>
      </FadeIn>

      <UrgencyBanner data-id="element-217" />

      <FadeIn delay={0.1} data-id="element-218">
        <PricingSelector variant="full" idPrefix="main-" data-id="element-219" />
      </FadeIn>
    </Section>;
}